import { render, staticRenderFns } from "./AppAnnuled.vue?vue&type=template&id=28ccb8fa&"
import script from "./AppAnnuled.vue?vue&type=script&lang=js&"
export * from "./AppAnnuled.vue?vue&type=script&lang=js&"
import style0 from "./AppAnnuled.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports